import React from "react";
import { twMerge } from "tailwind-merge";

type ButtonProps = {
  variant?: "gradient" | "secondary" | "ghost";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const VARIANT_CLASSES = {
  gradient:
    "bg-brand-gradient text-white font-semibold shadow-sm hover:opacity-90 active:opacity-80",
  secondary:
    "bg-surface-inset text-ink-primary font-semibold border border-line-subtle hover:border-line-strong active:bg-surface-raised",
  ghost:
    "bg-transparent text-ink-secondary font-medium hover:bg-surface-inset active:bg-surface-raised",
};

const SIZE_CLASSES = {
  sm: "text-sm px-3 py-1.5 rounded-lg gap-1.5",
  md: "text-sm px-4 py-2.5 rounded-[10px] gap-2",
  lg: "text-base px-5 py-3 rounded-xl gap-2",
};

function Button({
  variant = "secondary",
  size = "md",
  fullWidth = false,
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      className={twMerge(
        "inline-flex items-center justify-center transition-colors cursor-pointer select-none disabled:opacity-50 disabled:pointer-events-none",
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        fullWidth && "w-full",
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
